import Button from "./Button";
const DownloadLink = ({ link, children }) => {
    const handleDownload = async () => {
        window.open(link, '_blank');
    };

    return (

        <Button onClick={handleDownload}>{children}</Button>
    );
};

export default DownloadLink;